export default {
      id: "playArrow-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#playArrow-usage",
      toString: function () {
        return this.url;
      }
    }